<div id="ip-common">
  <header>
    @if (!isProduction) {
      <lib-environment-banner></lib-environment-banner>
    }
  </header>
  <main id="main-content">
    <div class="container-lg position-relative flex-fill"></div>
    @if (!hasError) {
      <router-outlet></router-outlet>
    }
  </main>
</div>
